import Mock from "mockjs";
import setupMock from "@/utils/setupMock";

const METHODS = ["GET", "POST", "PUT", "DELETE"];
const PATHS = [
  "/cdk/list",
  "/cdk/generate",
  "/cdk/export",
  "/game/list",
  "/game/info/6914",
  "/member/index",
  "/account/drm/list",
  "/system/user/list",
];
const USERS = ["admin", "operator", "guest", "system"];
const IPS = ["10.0.0.12", "10.0.0.31", "172.16.8.5", "203.0.113.7"];
const ERRORS = [
  "Token 已过期",
  "权限不足",
  "参数校验失败：gameId 不能为空",
  "上游服务超时",
];

let seq = 1000;
const records = Array.from({ length: 68 }).map((_, index) => {
  const statusRoll = Math.random();
  const status =
    statusRoll > 0.85
      ? 500
      : statusRoll > 0.72
      ? 401
      : statusRoll > 0.6
      ? 400
      : 200;
  const duration = Math.floor(Math.random() * 1800) + 20;
  const created = new Date(Date.now() - index * 3600 * 1000);
  return {
    id: seq++,
    method: METHODS[Math.floor(Math.random() * METHODS.length)],
    path: PATHS[Math.floor(Math.random() * PATHS.length)],
    ip: IPS[Math.floor(Math.random() * IPS.length)],
    userName: USERS[Math.floor(Math.random() * USERS.length)],
    userId: Math.floor(Math.random() * 10) + 1,
    status,
    duration,
    errorMsg:
      status >= 400 ? ERRORS[Math.floor(Math.random() * ERRORS.length)] : "",
    createdAt: created
      .toLocaleString("zh-CN", { hour12: false })
      .replace(/\//g, "-"),
  };
});

const applyFilter = (
  list: typeof records,
  keyword?: string,
  method?: string,
  startDate?: string,
  endDate?: string
) => {
  return list.filter((item) => {
    if (method && item.method !== method) return false;
    if (keyword) {
      const kw = keyword.toLowerCase();
      const hit =
        item.path.toLowerCase().includes(kw) ||
        item.ip.toLowerCase().includes(kw) ||
        (item.userName || "").toLowerCase().includes(kw);
      if (!hit) return false;
    }
    const day = (item.createdAt || "").slice(0, 10);
    if (startDate && day < startDate) return false;
    if (endDate && day > endDate) return false;
    return true;
  });
};

setupMock({
  setup: () => {
    Mock.mock(new RegExp("/cdk/access/logs"), (options) => {
      const url = new URL(options.url, "http://mock.local");
      const page = Number(url.searchParams.get("page") || 1);
      const pageSize = Number(url.searchParams.get("pageSize") || 10);
      const keyword = url.searchParams.get("keyword") || undefined;
      const method = url.searchParams.get("method") || undefined;
      const startDate = url.searchParams.get("startDate") || undefined;
      const endDate = url.searchParams.get("endDate") || undefined;
      const filtered = applyFilter(
        records,
        keyword,
        method,
        startDate,
        endDate
      );
      const start = (page - 1) * pageSize;
      return {
        code: 200,
        data: {
          list: filtered.slice(start, start + pageSize),
          total: filtered.length,
        },
        message: "ok",
      };
    });

    Mock.mock(new RegExp("/cdk/access/log/stats"), () => {
      const total = records.length;
      const error = records.filter((item) => Number(item.status) >= 400).length;
      const avgDuration = Math.round(
        records.reduce((sum, item) => sum + item.duration, 0) / (total || 1)
      );
      return {
        code: 200,
        data: {
          today: records.filter((item) =>
            (item.createdAt || "").startsWith(
              new Date().toISOString().slice(0, 10)
            )
          ).length,
          success: total - error,
          error,
          avgDuration,
          qps: 42,
          total,
        },
        message: "ok",
      };
    });
  },
});
